import { _sharedActionsConstantsPlayer } from "./actions";

export const _sharedStatePlayer = {
  waveformsDictionary: {},
  isSmallPlayerVisible: false,
  brokenAudios: [],
};

export const _sharedReducerPlayer = (state, action) => {
  switch (action.type) {
    case _sharedActionsConstantsPlayer.PUT_AUDIO_WAVE: {
      const { waveform, paragraphsAudioPositions, chapterId } = action.data;

      if (!waveform && !paragraphsAudioPositions) {
        return state;
      }

      return {
        ...state,
        waveformsDictionary: {
          ...state.waveformsDictionary,
          [chapterId]: {
            waveform,
            paragraphsAudioPositions,
          },
        },
      };
    }
    case _sharedActionsConstantsPlayer.SET_BROKEN_AUDIOS: {
      return { ...state, brokenAudios: action.data };
    }
    case _sharedActionsConstantsPlayer.SET_IS_SMALL_PLAYER_VISIBLE: {
      return { ...state, isSmallPlayerVisible: action.data };
    }
    default:
      return state;
  }
};
